import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=6ebfb148&scoped=true"
import script from "./Init.ts?vue&type=script&lang=ts&external"
export * from "./Init.ts?vue&type=script&lang=ts&external"
import style0 from "./Init.vue?vue&type=style&index=0&id=6ebfb148&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfb148",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ebfb148')) {
      api.createRecord('6ebfb148', component.options)
    } else {
      api.reload('6ebfb148', component.options)
    }
    module.hot.accept("./Init.vue?vue&type=template&id=6ebfb148&scoped=true", function () {
      api.rerender('6ebfb148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/FilesEditor/pages/Init/Init.vue"
export default component.exports